var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.blockClasses},[_c('p',{staticClass:"vac-stepper__label"},[_vm._v(_vm._s(_vm.current)+" / "+_vm._s(_vm.max))]),_c('div',{staticClass:"vac-stepper__steps"},_vm._l((_vm.max),function(index){return _c('div',{key:index,class:_setup.getClassForStep(index)})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }